import { Component, OnDestroy } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MaterialModule } from '@app/shared/material.module'
import { Select } from '@ngxs/store'
import { QuoteSessionState } from '@app/shared/store/quote-session/quote-session.state'
import { map, Observable, Subject, takeUntil } from 'rxjs'
import { Contact } from '@app/models/contact'
import { BrandCallSourceHistoryItem } from '@app/models/brand-call-source-history.model'

@Component({
    selector: 'app-brand-call-source-history',
    standalone: true,
    imports: [CommonModule, MaterialModule],
    templateUrl: './brand-call-source-history.component.html',
    styleUrls: ['./brand-call-source-history.component.scss'],
})
export class BrandCallSourceHistoryComponent implements OnDestroy {
    @Select(QuoteSessionState.contactState)
    public contact$!: Observable<Contact>

    public historyItems$: Observable<BrandCallSourceHistoryItem[]>
    public hasHistory$: Observable<boolean>
    public contactFullName$: Observable<string>

    #ngUnsubscribe$: Subject<void> = new Subject()

    constructor() {
        this.contactFullName$ = this.contact$.pipe(
            map((c) => `${c?.firstName ?? 'Pet'} ${c?.lastName ?? 'Parent'}`)
        )

        this.historyItems$ = this.contact$.pipe(
            map((c) => {
                const history = c?.callSources || []
                // Sort by addedOn descending (most recent first)
                return [...history].sort((a, b) => {
                    const dateA = new Date(a.addedOn).getTime()
                    const dateB = new Date(b.addedOn).getTime()
                    return dateB - dateA
                })
            })
        )

        this.hasHistory$ = this.historyItems$.pipe(
            map((items) => items && items.length > 0)
        )
    }

    ngOnDestroy(): void {
        this.#ngUnsubscribe$.next()
        this.#ngUnsubscribe$.complete()
    }
}
